import {
  Alert,
  AlertTitle,
  Button,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import {
  PopupNotification,
  useBluPopupNotification,
} from './PopupNotificationContext';
import { useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';

export const NotificationItem = ({
  notification,
}: {
  notification: PopupNotification;
}) => {
  const { removeNotification } = useBluPopupNotification();

  const cancelNotification = useCallback(() => {
    removeNotification(notification.id);
    if (notification.handleCancel) {
      notification.handleCancel();
    }
  }, [notification, removeNotification]);

  // Implementation of NotificationItem component
  return (
    <Alert
      key={notification.id}
      variant={notification.variant}
      severity={notification.type}
      onClose={notification.isCancellable ? cancelNotification : undefined}
      action={
        <Stack
          // alignContent="center"
          // justifyItems={'center'}
          // justifyContent={'center'}
          // alignItems={'center'}
          sx={{ height: '100%', width: 'fit-content' }}
        >
          <Stack alignContent={'end'} alignItems={'end'}>
            {notification.isCancellable && (
              <IconButton
                onClick={cancelNotification}
                color="inherit"
                size="small"
              >
                <CloseIcon color="inherit" />
              </IconButton>
            )}
          </Stack>
          <Stack flex="1" />

          <Stack direction="row" spacing={1}>
            {notification?.handleDecline ? (
              <Button
                // variant="button"
                variant="outlined"
                onClick={() => {
                  notification.handleDecline();
                  cancelNotification();
                }}
                style={{
                  cursor: 'pointer',
                  marginLeft: 16,
                  width: 'fit-content',
                  minWidth: 30,
                  padding: '0px 12px',
                }}
              >
                {notification.declineText || 'No'}
              </Button>
            ) : undefined}
            {notification?.handleConfirm ? (
              <Button
                // variant="button"
                onClick={() => {
                  notification.handleConfirm();
                  cancelNotification();
                }}
                style={{
                  cursor: 'pointer',
                  marginLeft: 16,
                  // padding: 0,
                  width: 'fit-content',
                  minWidth: 30,
                  padding: '0px 12px',
                }}
              >
                {notification.confirmText || 'Si'}
              </Button>
            ) : undefined}
          </Stack>
        </Stack>
      }
      sx={{
        backgroundColor:
          notification.variant === 'outlined' ? 'background.paper' : undefined,
        boxShadow: 3,
        maxWidth: '500px',
      }}
    >
      {notification?.title !== undefined && (
        <AlertTitle color="inherit">{notification.title}</AlertTitle>
      )}
      <Typography variant="body2" component="div" sx={{ color: 'inherit' }}>
        <div dangerouslySetInnerHTML={{ __html: notification.message }} />
      </Typography>
    </Alert>
  );
};
